// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'qualityMax4', standalone: true, pure: true })
export class QualityScoreMax4Pipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null || !Number.isFinite(value)) return '-';

    const str = String(value);

    if (str.length <= 4) return str;

    const isNeg = value < 0;
    const slots = 4;
    const signSlots = isNeg ? 1 : 0;
    const avail = slots - signSlots;
    const absVal = Math.abs(value);

    const intStr = Math.trunc(absVal).toString();

    if (intStr.length >= avail) {
      return (isNeg ? '-' : '') + intStr.slice(0, avail);
    }

    if (absVal === Math.trunc(absVal)) {
      return (isNeg ? '-' : '') + intStr;
    }

    let decimals = avail - intStr.length - 1;
    if (decimals < 0) decimals = 0;

    const scale = Math.pow(10, decimals);
    const truncated = Math.trunc(absVal * scale) / scale;

    let out = (isNeg ? '-' : '') + truncated.toFixed(decimals);

    while (out.length > slots && decimals > 0) {
      decimals--;
      const s = Math.pow(10, decimals);
      const t = Math.trunc(absVal * s) / s;
      out = (isNeg ? '-' : '') + t.toFixed(decimals);
    }

    if (out.length > slots) {
      return (isNeg ? '-' : '') + intStr.slice(0, avail);
    }
    return out;
  }
}